import { Component } from '@angular/core';

@Component({
  selector: 'app-camzo-coming-soon',
  standalone: true,
  template: `
    <div class="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 py-12 px-4 sm:px-6">
      <div class="max-w-6xl mx-auto">

       

        <!-- Video -->
        <div
          class="overflow-hidden rounded-2xl shadow-2xl border border-slate-700 bg-black mb-12">
          <div class="aspect-video">
            <iframe
              class="w-full h-full"
              src="https://www.youtube.com/embed/pxa6xA2cPUg"
              title="Camzo Coming Soon"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen>
            </iframe>
          </div>
        </div>

         <!-- Header -->
        <div class="text-center mb-10">
          <h2 class="text-xl font-bold text-white mb-4">
            Camzo is Coming Soon
          </h2>

          <p class="text-base sm:text-lg lg:text-xl text-slate-300 max-w-3xl mx-auto">
            We're building something amazing. Stay tuned for exciting updates and
            get ready to experience Camzo like never before.
          </p>
        </div>

        <!-- Features -->
        <div class="text-center mb-8">
          <h3 class="text-2xl md:text-3xl font-semibold text-white">
            Key Features
          </h3>
        </div>

        <div
          class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              2K Front + 1K Rear
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              130° Wide Angle
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              Loop Recording
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              G-Sensor + Motion Detection
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              Wi-Fi Connectivity
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              Live View & Playback
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              Trip Reports & Driving Feedback
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              Contextual Alerts
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              Varroc Miles Ready
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              E-commerce & Offers
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              32GB–256GB SD Card Support
            </h3>
          </div>

          <div
            class="bg-slate-800/70 border border-slate-700 rounded-xl p-5 hover:border-blue-500 transition-all duration-300">
            <h3 class="text-white font-semibold text-lg">
              1-Year Warranty
            </h3>
          </div>

        </div>

      </div>
    </div>
  `,
  styles: []
})
export class CamzoComingSoonComponent {}